<template>
  <div class="send-bulk-container">
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <div class="custom-row">
        <div class="col">
          <div class="upload-container">
            <p class="pimary-input-title">Add a file <strong>(.xlsx only)</strong></p>
            <app-dropzone @fileAdd="fileAdded($event)" @remove="fileRemoved($event)" :optionsProp="dropzoneOptions" />
          </div>
        </div>
      </div>
      <div v-if="file" class="buttons-wrapper">
        <primary-button
          @click.native="SendBulk"
        >Submit Now</primary-button>
      </div>
      <div v-if="bulkUuid" class="buttons-wrapper">
        <primary-button
          @click.native="$router.push({name: 'company-admin-bulkSending-history'})"
        >Ok! UUID is: {{ bulkUuid }}. Go to the History tab for details</primary-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    Loader: () => import("@/components/Loader.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  data: () => ({
    loading: true,
    bulkUuid: null,
    file: null,
    enabledUpload: true,
    dropzoneOptions: {
      acceptedFiles: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }),
  created() {
    this.loading = false;
  },
  beforeDestroy() {
    this.bulkUuid = null;
  },
  methods: {
    fileAdded(file) {
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false; 
      }
    },
    fileRemoved() {
      if(!this.file) {
        this.bulkUuid = null;
      }

      this.file = null;
    },
    SendBulk() {
      let data = new FormData();

      data.append("file", this.file);
      data.append("type", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

      this.$store
        .dispatch("BulkSend", data)
        .then(res => {
          this.fileRemoved();
          this.bulkUuid = res.data.object_uuid;
        });

      console.log('click btn');
    }
  },
};
</script>

<style lang="scss" scoped>
.send-bulk-container {
  padding: 50px 0 0 0;

  .perPage {
    width: 120px;
    display: inline-block;
  }
  .custom-row {
    width: 100%;
    display: flex;
    margin-top: 20px;
    span {
      margin-top: 7px;
      margin-right: 10px;
    }
  }

  .buttons-wrapper {
    width: 100%;
    justify-content: flex-end;
    padding: 30px 30px 0 15px;
  }

  @media (max-width: 891px) {
    .right-wrapprr {
      width: 100% !important;
    }
  }
  @media (max-width: 767px) {
    .add-navigation {
      display: block !important;
      height: auto !important;
    }
    .custom-row {
      width: 100% !important;
    }
    .buttons-wrapper {
      width: 100%;
      justify-content: flex-start !important;
      margin-top: 15px;
    }
  }
  @media (max-width: 600px) {
    .custom-row {
      display: block !important;
    }

    .buttons-wrapper {
      width: 100% !important;
    }
    .col-lg-6.col-md-7.col-xs-12 {
      margin-top: 15px;
    }
  }
  .add-navigation {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;

    .search-input {
      height: 40px;
      width: 345px;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 15px;
    }
  }
}
</style>
